import { createStateSelectorHook } from 'src/lib/sweetState';
import { ProjectFolderStore } from 'src/store';

const useProjectFolderState = createStateSelectorHook(ProjectFolderStore, ['projectFolders']);

export const useViewState = () => {
  const { projectFolders } = useProjectFolderState();
  return { projectFolders };
};
